export default "__VITE_ASSET__68d7bcd5__"